/**
 * @name processEngTextNoDecimal
 * @function
 * @description Raises a number to a power of 10 without needing to use the decimal value of the number if possible.
                Example where this function helps; previously the following could happen:  1.1*Math.pow(10,2) = 110.00000000000001
                This function turns the above into 11*Math.pow(10,1)
 * @returns {JSX}
 * @param {*} props
 */
var processEngTextNoDecimal = function (value, powToRaiseTo) {
    if (isNaN(value)) {
        return " ";
    }
    var decrementer = 0;
    var powValue = powToRaiseTo;
    var modifiedValue = value;
    var valuePieces = value.split(".");
    if (valuePieces.length > 1) {
        decrementer = valuePieces[1].length;
        modifiedValue = value.replace(".", "");
    }
    powValue = powToRaiseTo - decrementer;
    if (powValue < 0) {
        modifiedValue = value;
        powValue = powToRaiseTo;
    }

    return modifiedValue * Math.pow(10, powValue);
};

/**
 * @name numberInSuffixRange
 * @function
*  @description  Checks if the number is in a range that matches an engineering suffix
                 For example if suffix is 'k', this function checks if the number is between 1000 and 1e6
 * @param {string} suffix - Engineering suffix of the band we want to check.
 * @param {string} bigSuffix - Next biggest suffix, in case of numbers like 999.9999 which get rounded up.
 * @param {number} smallestNumber - Lowest number in the range. For example if small suffix is k, then this is 1000.
 * @param {number} numberToCheck - The number we actually want to check.
 * @param {number} significantDigits - How many significant digits the returned number should have.
 * @returns {(string|null)} Returns null if number not in range, otherwise returns formatted number.    
*/

var numberInSuffixRange = function (suffix, bigSuffix, smallestNumber, numberToCheck, significantDigits) {
    var engineeringText,
        suffixToUse,
        smallValToCheck = smallestNumber * 1000;

    if (numberToCheck < smallValToCheck.toPrecision(15)) {
        engineeringText = ((numberToCheck / smallestNumber).toPrecision(significantDigits)).toString() + suffix;

        //if the orginal number was 100,000, after the multiplication it will be 100 which the toPrecision will convert to something like 1.02e+2 
        //To avoid showing the customer something like 1.0e+2k, we have the code below
        var eMatch = engineeringText.match(/e/i);
        if (eMatch) {
            var significand = engineeringText.slice(0, eMatch.index);
            var exponent = engineeringText.slice(eMatch.index + 2, eMatch.index + 3);

            if (exponent === '3') {
                suffixToUse = bigSuffix; exponent = '0';
            }
            else {
                suffixToUse = suffix;
            }
            engineeringText = processEngTextNoDecimal(significand, exponent) + suffixToUse;
        }

        return engineeringText;
    }
    else return null;
};

/**
 * @name removeZeroes
 * @function
 * @description  Removes zeroes from a number string.
 *
 * @param {string} numberString - The input number string.
 * @returns {string} The number string with trailing zeroes removed.
 */
  var removeZeroes = function (numberString) {
    //Must have numbers followed by a period followed by more numbers for this function to do anything
    var matchReturn = numberString.match(/^[0-9]+\.[0-9]+/);
    if (matchReturn) {
        var numberWithZeroes = numberString.slice(0, matchReturn[0].length);
        var restOfString = numberString.slice(matchReturn[0].length);
        var numberWithoutZeroes = numberWithZeroes.replace(/0*$/, '');
        var remDot = numberWithoutZeroes.replace(/\.$/, ''); // removing the trailing dot
        return (remDot + restOfString);
    }
    else
        return numberString;
};

/**
 * @name metricStringToNumber
 * @function
 * @description  Converts a string with a metric suffix to a number.
 * @param {string} numberString - The input number string.
 * @returns {string} The number string with trailing zeroes removed.
 */
var metricStringToNumber = function (textFromUser, regEx, exponent) {
    var number, pattern;
    //remove the suffix
    textFromUser = textFromUser.replace(regEx, "").toString();
    //check if rest of the part has digits and decimal
    if (textFromUser.match(/[0-9]$/g) || textFromUser.match(/\W+/g)) {
        //turn the number into numeric format
        pattern = parseFloat(textFromUser);
        //multiply by exponent
        var expo = Math.pow(10, exponent);
        number = expo * pattern;
        //Limit to 12 significant digits to avoid floating point errors
        //Otherwise you can get stuff like 30 * 1e-9 = 3.0000000000000004e-8
        var chopSomeDigitsOff = number.toPrecision(12);
        number = parseFloat(chopSomeDigitsOff);
    }
    else number = NaN;
    return number;
};


  window._qfCommon = {
    getFormValues: function (formId) {
        var result = {},
            selfRef = this;

        var form = this.domAccessors.select(formId);

        form.querySelectorAll('[name]').forEach(function (item) {

            if ((item.type !== 'radio' && item.type !== 'checkbox')
                || ((item.type === 'radio' || item.type === 'checkbox') && item.checked !== false)) {

                var v = item.value;

                // Check if pretty input.
                if (item.getAttribute('data-prettynum') === "true") {
                    var pnResult = selfRef.prettyNum.userEntryToNumber(v);

                    if (typeof pnResult[1] !== 'undefined' && !pnResult[1]) v = pnResult[0];
                }

                result[item.name] = v;
            }
        });

        return result;
    },

/**
 * 
 * @name chkQsErr
 * @function
 * @description Checks the validity of a value based on specified validations.
 * @param {Array} errors - Input/output list of errors. Must be initialized on start.
 * @param {string|number} value - Value to test.
 * @param {string} caption - Description of the value for error messages.
 * @param {string} vd - String that contains validation characters (n,p,>,^,r).
*                       n: is numeric
                        p: is positive
                        >: Is >= value to check against (next param)
                        ^: Is < value to check against
                        r: Required field; check it has a value. This also throws an error if value===0.
 * @param {string|number} cvalue - Value to check against.
 * @param {string} ccaption - Description of the comparison value for error messages.
 * @returns {number} Processed value, which may have been converted to a Float.
 */
    chkQsErr: function (errors, value, caption, vd, cvalue, ccaption) {

        var r = false, //Is it required
        rValue = value,
        vv = vd.split('');

        for (let i = 0; i < vv.length; i++) {
            switch (vv[i]) {
                case "n":
                    if (value == '' && r == false) {
                    } else if (isNaN(value)) {
                        errors.push(caption + " should be a number");
                    } else {
                        rValue = parseFloat(value);
                    }
                    break;
                case "p":
                    if (value == '' && r == false) {
                    } else if (isNaN(value) || parseFloat(value) <= 0) {
                        errors.push(caption + " should be a positive number");
                    } else {
                        rValue = parseFloat(value);
                    }
                    break;
                case ">":
                    if (parseFloat(value) <= parseFloat(cvalue)) {
                        errors.push(caption + " should be greater than " + ccaption);
                    }
                    break;
                case "<":
                    if (parseFloat(value) >= parseFloat(cvalue)) {
                        errors.push(caption + " should be less than " + ccaption);
                    }
                    break;
                case "^":
                    if (parseFloat(value) < parseFloat(cvalue)) {
                        errors.push(caption + " should be greater than or equal to " + ccaption);
                    }
                    break;
                case "v":
                    if (parseFloat(value) > parseFloat(cvalue)) {
                        errors.push(caption + " should be less than or equal to " + ccaption);
                    }
                    break;
                case "r":
                    if (!value || value == '') {
                        //errors.push(caption + " is required");
                    }
                    r = true;
                    break;
                default: //Unknown validation option, exit.
                    errors.push("Unknown validation option");
                    return;
            }
        }

        return rValue;
    },

    handleErrors: function (errors, id) {
        if (errors.length === 0) {
            this.domAccessors.select('#qserrors').innerHTML = '';
            return true;
        }
           
        this.domAccessors.select( id ).innerHTML = ( errors.length === 1 ) ? "Error: " + errors : "Errors:<br><ul><li>" + errors.join( '</li><li>' ) + "</li></ul>";

        return false;
    },

    qsAddFilters: function (qstr, param, values) {
        if (qstr !== "")
            qstr += "&";

        qstr += "p" + param + "=";

        if (Array.isArray(values))
            qstr += values.join('|');
        else
            qstr += values;

        return qstr;
    },

    qsAddColumns: function (qstr, params) {
        if (qstr !== "") qstr += "&";

        qstr += "ca=";

        if (Array.isArray(params))
            qstr += params.join('|');
        else
            qstr += params;

        return qstr;
    },

    getQsFormValues: function (formId) {
        var form = this.domAccessors.select("#" + formId);
        var formValues = "";

        form.querySelectorAll('[name]').forEach(function (item) {
            if ((item.type !== 'radio' && item.type !== 'checkbox')
                || ((item.type === 'radio' || item.type === 'checkbox') && item.checked !== false)) {

                formValues += item.name + "|" + item.value + "_";

            }
        });

        formValues = formValues.slice(0, -1);

        return formValues;
    },

    setQsFormValues: function (formValuesString) {
        var values = formValuesString.split("_");
        var _select = this.domAccessors.select;

        for (var i = 0; i < values.length; i++) {
            var pair = values[i];
            var keyValue = pair.split("|");
            var element = _select("#" + keyValue[0]);

            if (keyValue[1] == "on" && element.type === 'checkbox') {
                element.checked = true;
            } else {
                element.value = keyValue[1];
            }
        }
    },

    accMul: function (arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try { m += s1.split(".")[1].length } catch (e) { }
        try { m += s2.split(".")[1].length } catch (e) { }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },

    sigFigs: function (n, sig) {
        var mult = Math.pow(10, sig - Math.floor(Math.log(n) / Math.LN10) - 1);
        var val = Math.round(n * mult) / mult;
        return (isNaN(val)) ? 0 : val;
    },

    accAdd: function (arg1, arg2) {
        var r1, r2, m;
        try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    },

    accDiv: function (arg1, arg2) {
        var t1 = 0, t2 = 0, r1, r2;
        try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
        try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
        
        r1 = Number(arg1.toString().replace(".", ""))
        r2 = Number(arg2.toString().replace(".", ""))
        return (r1 / r2) * (Math.pow(10, t2 - t1));
        
    },

    // This gets bound to the search button.
    _search: function () {
        var query = window._qfCode.quickSearch();
        var _select = window._qfCommon.domAccessors.select;

        if (query) {
            var href = (window.location.protocol + '//' + window.location.host + '/' + _select('#quickFilterLocale').textContent + '/parametricsearch/' + _select('#quickFilterPstId').textContent + '#/' + query);

            window.location.href = href
        }
    },

    // Pretty Num
    prettyNum: {
        /*This function now accepts positive and negative float values.*/
        userEntryToNumber: function (textFromUser) {
            if (textFromUser) {
                var mu = String.fromCharCode(181);
                if (textFromUser.indexOf(mu) != -1) {
                    var muI = textFromUser.indexOf(mu);
                    textFromUser = textFromUser.substr(0, muI) + 'u' + textFromUser.substr(muI + 'u'.length);
                }

                var INFINITY = 1 * Math.pow(10, 60); //1e60
                var NEGINFINITY = -1 * Math.pow(10, 60); //-1e60

                var invalidUserEntry;
                invalidUserEntry = false; // boolean value setting to false.
                var number;
                var patterninf = /^inf/i; // i is search with ignore case character and ^ is to search the start of a string, $ matches the end of the string
                var patternNeginf = /^-inf/i; // pattern for negative infinity

                textFromUser = textFromUser.replace(/\s+/g, ""); // trimming all the spaces which user can input

                if (textFromUser.match(patterninf)) {
                    number = INFINITY;
                }
                else if (textFromUser.match(patternNeginf)) {
                    number = NEGINFINITY;
                }
                else if (textFromUser.match(/T$/g)) {
                    number = metricStringToNumber(textFromUser, /T$/g, 12);
                }
                else if (textFromUser.match(/G$/g)) { // checks if the last character is G
                    number = metricStringToNumber(textFromUser, /G$/g, 9);
                }
                else if (textFromUser.match(/M$/g)) { // checks if the last character is M
                    number = metricStringToNumber(textFromUser, /M$/g, 6);
                }
                else if (textFromUser.match(/k$/g)) { // checks if the last character is k
                    number = metricStringToNumber(textFromUser, /k$/g, 3);
                }
                else if (textFromUser.match(/m$/g)) {
                    number = metricStringToNumber(textFromUser, /m$/g, -3);
                }
                else if (textFromUser.match(/u$/g)) {
                    number = metricStringToNumber(textFromUser, /u$/g, -6);
                }
                else if (textFromUser.match(/n$/g)) {
                    number = metricStringToNumber(textFromUser, /n$/g, -9);
                }
                else if (textFromUser.match(/p$/g)) {
                    number = metricStringToNumber(textFromUser, /p$/g, -12);
                }
                else if (textFromUser.match(/f$/g)) {
                    number = metricStringToNumber(textFromUser, /f$/g, -15);
                }
                else if (textFromUser.match(/a$/g)) {
                    number = metricStringToNumber(textFromUser, /a$/g, -18);
                }
                else if (textFromUser.match(/E/gi)) {
                    number = textFromUser;
                }
                else if (textFromUser.match(/^[-+]?[0-9]*$/g) || textFromUser.match(/^[-+]?(?:\d*\.\d{0,20}|\d+)$/)) {
                    textFromUser = parseFloat(textFromUser);
                    number = Number(textFromUser);
                }
                else if (textFromUser.match(/s$/g)) {
                    number = textFromUser;
                }
                else {
                    number = "";
                    invalidUserEntry = true;
                } //end of else if chain

                if ((isNaN(number)) || (number === null) || (number === undefined)) {
                    number = "";
                } //end of  if // if the number is NaN, it will return a space
            }

            return [number, invalidUserEntry];
        },

        /**
         * Shorthand function for numberToUserDisplay with Engineering notation, 3 significant digits, and no extra zeroes.
         * @param {number} number - The input number.
         * @returns {string} Returns the formatted number.
         */
        eng3: function (number) {
            return this.numberToUserDisplay(number, "Engineering", 3, false);
        },

         /**
         * Shorthand function for numberToUserDisplay with Engineering notation, 4 significant digits, and no extra zeroes.
         * @param {number} number - The input number.
         * @returns {string} Returns the formatted number.
         */
        eng4: function (number) {
            return this.numberToUserDisplay(number, "Engineering", 4, false);
        },

        /**
         * Converts a number to a nice looking format.
         * @param {number|string} number - The input number or string.
         * @param {string} displayFormat - The display format ("Engineering", "Scientific", or other defaults to floating point).
         * @param {number} significantDigits - The number of significant digits.
         * @param {boolean} showZeroes - Set to false to remove extra zeroes.
         * @returns {string} Returns the formatted number.
         **/
        numberToUserDisplay: function (number, displayFormat, significantDigits, showZeroes) {
            var textToDisplay,
                absNumber,
                sign,
                engineeringText,
                scientificText,
                floatingText,
                smallestNumber,
                INFINITY = 1 * Math.pow(10, 60), //1e60
                NEGINFINITY = -1 * Math.pow(10, 60), //-1e60
                suffixList = ['a', 'f', 'p', 'n', 'u', 'm', '', 'k', 'M', 'G', 'T', 'P'];

            //check for valid input
            if ((isNaN(number)) || (number === null) || (number === undefined)) return "";
            if (number === 0) return '0';
            if (number >= INFINITY) return "Inf";
            else if (number <= NEGINFINITY) return "-Inf";

            //Allow this function to be used with string inputs as well.
            if (typeof number == 'string' || number instanceof String) {

                number = number.trim();

                if (number.match(/[a-zA-Z]/gi)) {
                    var call_userEntryToNumber = this.userEntryToNumber(number);
                    number = call_userEntryToNumber[0];
                }

                if ((number == "") || isNaN(number)) return "";
            }

            //Engineering notation
            if (displayFormat === "Engineering") {
                absNumber = Math.abs(number);
                sign = number / absNumber;
                smallestNumber = 1e-18;

                if (absNumber < smallestNumber) {
                    return '0';
                }
                else {
                    var loopFinished = true;
                    for (var i = 0; i < suffixList.length - 1; i++) {
                        //Check if number is a number that would normally have suffixList[i] after it. If so, return formatted number.
                        engineeringText = numberInSuffixRange(suffixList[i], suffixList[i + 1], smallestNumber, absNumber, significantDigits);
                        if (engineeringText) {
                            loopFinished = false;
                            break;
                        }
                        else smallestNumber *= 1000;
                    }
                    if (loopFinished) {
                        engineeringText = "Inf";
                    }
                }
                if (showZeroes === false) {
                    engineeringText = removeZeroes(engineeringText);
                }
                if (sign < 0) {
                    engineeringText = '-' + engineeringText;
                }
                textToDisplay = engineeringText;
            }

                //Scientific notation
            else if (displayFormat === "Scientific") {
                scientificText = number.toExponential(significantDigits);
                if (showZeroes === false) {
                    scientificText = removeZeroes(scientificText);
                }
                textToDisplay = scientificText;
            }

                //Floating point notation
            else {
                floatingText = (number.toPrecision(significantDigits)).toString();
                if (showZeroes === false) {
                    floatingText = removeZeroes(floatingText);
                }
                textToDisplay = floatingText;
            }

            return textToDisplay;
        },

        areArraysIdentical: function (arr1, arr2) {
            if (arr1.length !== arr2.length) return false;
            for (var i = 0, len = arr1.length; i < len; i++) {
                if (arr1[i] !== arr2[i]) {
                    return false;
                }
            }
            return true;
        }
    },

    domAccessors: {
        baseElement: null, // This gets set on creation.

        // Used in place of $.on when you don't have the individual element or for when you want to bind a selection.
        // Example: 
        // delegateSelect(document, "click", ".some_elem", function (event) {
        //      this.style.border = "2px dashed orange";
        // });
        delegateSelect: function (el, evt, sel, handler) {
            el.addEventListener(evt, function (event) {
                var t = event.target;
                while (t && t !== this) {
                    if (t.matches(sel)) {
                        handler.call(t, event);
                    }
                    t = t.parentNode;
                }
            });
        },

        /**
         * Binds an event listener to an individual element.
         * @param {HTMLElement} el - The element to bind the event to.
         * @param {string} evt - The event type.
         * @param {Function} handler - The event handler function.
         */
        delegate: function (el, evt, handler) {
            el.addEventListener(evt, handler);
        },

        // Uses #quickFilterSearch as the base element.
        // This is a replacement for $(query).
        // Returns a single node when selecting starts with '#' else returns a note list.
        select: function (query, baseElement) {
            var baseElement = window._qfCommon.domAccessors.baseElement;
            return query[0] === '#' ? baseElement.querySelector(query) : baseElement.querySelectorAll(query);
        }
    },

    toggleMoreFeatures: function (expandableId) {
        var expandable = document.getElementById(expandableId);
        if (expandable) {
            expandable.style.display = expandable.style.display == "none" ? "block" : "none";
        }
    }
};